import { render, staticRenderFns } from "./TipsChart.vue?vue&type=template&id=fab3687a"
import script from "./TipsChart.vue?vue&type=script&lang=js"
export * from "./TipsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports